import PropTypes from "prop-types";
import React, { useState } from "react";

import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { withRouter, Link } from "react-router-dom";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginUser } from "../../store/actions";

// import images
import profile from '../../assets/images/Glottis - Logo shap.png';
import logo from "assets/images/welcome-logo.png";
import AuthLoader from "components/Common/AuthLoader";

const Login = props => {
  //meta title
  document.title = "Login | Glottis Logistics";

  const dispatch = useDispatch();
  const redirectUrl = (sessionStorage.getItem("redirectUrl"));

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().email('Enter valid email address').required("Enter email address"),
      password: Yup.string().required("Enter password"),
    }),
    onSubmit: (values) => {
      dispatch(loginUser(values, props.history, redirectUrl));
    }
  });
  const [passwordShow, setPasswordShow] = useState(false);
  const { error, loader} = useSelector(state => ({
    error: state.Login.error,
    loader: state.Login.loading,
  })); 

  return (
    <React.Fragment>
      <div className="account-pages">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <div className="text-center auth-logo">
                <img src={logo} alt="Logo" />
              </div>
              <Card className="overflow-hidden auth-card rounded-0">
                <div className="bg-primary bg-soft background-auth-page">
                  <Row className="align-items-center auth-head">
                    <Col xs={7} className='auth-heading'>
                      <div className="auth-heading-text">
                        <h2 className="f-size-24">Welcome Back !</h2>
                        <p className="f-size-12">Sign in to Glottis Tracking portal.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end logo-img">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="">
                  {/* <div className="d-inline-block">
                    <Link to="/" className="auth-logo-light">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt="Logo"
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div> */}
                  <div className="">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    > 

                      <div>
                        <Label className="form-label f-size-14">Email address <span>*</span></Label>
                        <Input
                          name="email"
                          className="form-control f-size-14"
                          type="email"
                          placeholder="email@address.com"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email ? true : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                        ) : null}
                      </div>

                      <div>
                        <Label className="form-label f-size-14">Password <span>*</span></Label>
                        <div className="input-group auth-pass-inputgroup">
                          <Input
                            className="password-input f-size-14"
                            name="password"
                            placeholder="*******"
                            value={validation.values.password || ""}
                            type={passwordShow ? "text" : "password"}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.password && validation.errors.password ? true : false
                            }
                          />
                          <button onClick={() => setPasswordShow(prevState => !prevState)} className="btn" type="button" id="password-addon">
                            {passwordShow ? <i className="mdi mdi-eye-outline"></i> : <i className="mdi mdi-eye-off-outline"></i>}
                          </button>
                          {validation.touched.password && validation.errors.password ? (
                            <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                          ) : null}
                        </div>
                      </div>

                      <div className="forgot-password d-flex justify-content-end">
                        <Link to="/forgot-password" className="f-size-12">
                          Forgot password?
                        </Link>
                      </div>                      
                      {loader === true ? <AuthLoader/>:
                      <div className="d-grid">
                        <button
                          className="btn btn-primary btn-block primary-button"
                          type="submit"
                          >
                          Login
                        </button>
                      </div>
                        }
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="text-center copy-right">
                <p> Glottis @ {new Date().getFullYear()} All Rights Reserved</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
